import React from 'react';
import {Helmet} from 'react-helmet';
import {sprintf} from 'sprintf-js';
import locales from '../../locales/locales';
import Navbar from '../navbar/navbar';
import Footer from '../footer/footer';
const PrivacyPolicy=({globalSettings})=>{
  return (
    <div className='min-h-screen flex flex-col bg-white'>
      <Helmet>
        <title>NekoTranslate - {locales.privacyTitle[globalSettings.lang]}</title>
      </Helmet>
      <Navbar globalSettings={globalSettings} />
      <div className='flex-1 bg-purple-50 pt-16'>
        <div className='max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24'>
          <div className='text-center mb-10'>
            <h1 className='text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight'>
              {locales.privacyHeadingPrefix[globalSettings.lang]}
              <span className='text-purple-800'>
                {locales.privacyHeadingHighlight[globalSettings.lang]}
              </span>
              {locales.privacyHeadingSuffix[globalSettings.lang]}
            </h1>
          </div>
          <div className='bg-white p-8 rounded-xl shadow-lg border border-gray-200'>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.privacyOverviewTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {locales.privacyOverviewContent[globalSettings.lang]}
              </p>
            </div>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.privacyDataCollectTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {locales.privacyDataCollectAccount[globalSettings.lang]}
              </p>
              <p className='text-gray-600 mb-4'>
                {locales.privacyDataCollectBilling[globalSettings.lang]}
              </p>
              <p className='text-gray-600 mb-4'>
                {locales.privacyDataCollectUsage[globalSettings.lang]}
              </p>
              <p className='text-gray-600 mb-4'>
                {locales.privacyDataCollectAnalytics[globalSettings.lang]}
              </p>
            </div>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.privacyPurposeTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {locales.privacyPurposeContent[globalSettings.lang]}
              </p>
            </div>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.privacyCookiesTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {locales.privacyCookiesContent[globalSettings.lang]}
              </p>
            </div>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.privacyStorageTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {locales.privacyStorageContent1[globalSettings.lang]}
              </p>
              <p className='text-gray-600 mb-4'>
                {locales.privacyStorageContent2[globalSettings.lang]}
              </p>
            </div>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.privacyDataSharingTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {locales.privacyDataSharingContent[globalSettings.lang]}
              </p>
            </div>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.privacyChildrenTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {locales.privacyChildrenContent[globalSettings.lang]}
              </p>
            </div>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.privacyRetentionTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {locales.privacyRetentionContent[globalSettings.lang]}
              </p>
            </div>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.privacyTransfersTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {locales.privacyTransfersContent[globalSettings.lang]}
              </p>
            </div>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.privacyUpdatesTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {locales.privacyUpdatesContent[globalSettings.lang]}
              </p>
            </div>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.privacyLanguageTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {locales.privacyLanguageContent[globalSettings.lang]}
              </p>
            </div>
            <div className='mb-8'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                {locales.privacyContactTitle[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 mb-4'>
                {sprintf(
                  locales.privacyContactContent[globalSettings.lang],
                  'legal@nekotranslate.ai',
                )}
              </p>
            </div>
          </div>
          <div className='mt-8 text-center'>
            <p className='text-gray-600'>
              {locales.privacyLastUpdated[globalSettings.lang]}
            </p>
          </div>
        </div>
      </div>
      <Footer globalSettings={globalSettings} />
    </div>
  );
};
export default PrivacyPolicy;

